module.exports = __webpack_public_path__ + "img/adelphi-logo-white.57703108.png";